import {
  Badge,
  Button,
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  Table
} from "reactstrap";
import React, {Component, Fragment} from "react";
import {getFormFieldValue, setFormFieldValue} from "../../containers/Applications/shared/shared";
import {getData} from "../../api/doLogin";
import {getLMSWBlacklistStatus} from "../../constants/LMSConstants";

export class LMSUserPicker extends Component {

  constructor(props) {
    super(props);
    this.state = {
      dataLoaded: false,
      data: [],
      totalResults: 0,
      formData: {},
      showIndicator: false,
      page: 1,
      limit: 15,
    }
  }

  minusHidden(totalResults) {
    if (this.props.hideUsers) {
      let returnedResults = totalResults - this.props.hideUsers.length;
      if (returnedResults < 0) {
        returnedResults = 0;
      }
      return returnedResults;
    }
    return totalResults;
  }

  filterUsers(data){
    if (this.props.hideUsers) {
      return data.filter(lead=>!this.props.hideUsers.includes(lead.id))
    }
    return data;
  }

  shouldComponentUpdate(nextProps, nextState) {
    // like writing return true
    return this.state.formData !== nextState.data || this.state.data !== nextState.data;
  }

  formsUpdater(evt) {
    setFormFieldValue(evt.target.id, evt.target.value, this.state['formData'], false, (data) => this.setState({formData: data}));
  }

  search(page = 1) {
    var self = this;
    const searchData = {
      q: this.state.formData['q'] || "",
      page: page,
      limit: 15
    };
    if (this.state.formData['all']) {
      searchData['all'] = true;
    }
    self.setState({showIndicator: true});
    getData("lms/leads", searchData, this.props.token)
      .then((data) => {
        if (data.status === "Success") {
          // console.log(data.data);
          self.setState({
            data: this.filterUsers(data.data.leads),
            dataLoaded: true,
            showIndicator: false,
            page: Number(data.data.page),
            totalResults: this.minusHidden(Number(data.data.results)),
            limit: Number(data.data.limit)
          });
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  needsPages() {
    return this.state.totalResults > this.state.limit;
  }

  maxPages() {
    return Math.ceil(this.state.totalResults / this.state.limit);
  }

  render() {
    return (
      <Modal isOpen={this.props.isOpen || false}
             className={'modal-lg ' + this.props.className}>
        <ModalHeader>Find User{this.props.title ? ` - ${this.props.title}` : ""}</ModalHeader>
        <ModalBody>
          <Row>
            <Col xs="3">
              <FormGroup>
                {/*<Label for="psk">Search</Label>*/}
                <Input
                  placeholder={"Search criteria"}
                  type="text"
                  id="q"
                  value={getFormFieldValue(this.state.formData['q'])}
                  onChange={(evt) => this.formsUpdater(evt)}
                  onKeyPress={(event) => {
                    if (event.key === 'Enter') {
                      this.search()
                    }
                  }}
                />
              </FormGroup>
            </Col>
            <Col xs="2">
              <Button onClick={() => this.search()}>Search</Button>
            </Col>
            <Col xs="2">
              <FormGroup check className="checkbox">
                <Input
                  className="form-check-input"
                  type="checkbox"
                  id="all"
                  name="all"
                  value="1"
                  checked={this.state.formData['all'] || false}
                  onChange={(evt) => {
                    if (this.state.formData['all']) {
                      this.setState({formData: {...this.state.formData, all: false}});
                    } else {
                      this.setState({formData: {...this.state.formData, all: true}});
                    }
                  }}
                />
                <Label check className="form-check-label" htmlFor="checkbox1">All Matches</Label>
              </FormGroup>
            </Col>
            {this.state.showIndicator && (
              <Col xs="1">
                <div className="sk-three-bounce" style={{margin: "7px auto"}}>
                  <div className="sk-child sk-bounce1"></div>
                  <div className="sk-child sk-bounce2"></div>
                  <div className="sk-child sk-bounce3"></div>
                </div>
              </Col>
            )}

          </Row>
          {this.state.dataLoaded ? this.state.data.length > 0 ? (
            <Fragment>
              <Table responsive size="sm">
                <thead>
                <tr>
                  <th>Name</th>
                  <th>Location</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
                </thead>
                <tbody>
                {this.state.data.map((lead, index) => {
                  const status = getLMSWBlacklistStatus(lead);
                  return <tr key={index}>
                    <td>{`${lead['rank']} ${lead['fname']} ${lead['lname']}`}</td>
                    <td>{`${lead['city']}, ${lead['state']} ${lead['branch']}`}</td>
                    <td><Badge style={{backgroundColor: status.bgColor, color: status.color}}>{status.display}</Badge>
                    </td>
                    <td><Button onClick={(evt) => {
                      this.props.onSelect(lead)
                    }}>Select</Button></td>
                  </tr>
                })}
                </tbody>
              </Table>
              <Pagination>
                {this.needsPages() && this.state.page > 1 && (
                  <PaginationItem><PaginationLink previous onClick={(evt) => {
                    this.search(Number(this.state.page) - 1);
                  }}>Prev</PaginationLink></PaginationItem>
                )}

                {this.generatePageLinks().map((page, index) => {
                  return <PaginationItem active={page.active} key={index}>
                    <PaginationLink onClick={() => {
                      if (!page.active) {
                        this.search(page.num);
                      }
                    }}>{page.num}</PaginationLink>
                  </PaginationItem>
                })}

                {this.needsPages() && this.state.page < this.maxPages() && (
                  <PaginationItem><PaginationLink next onClick={(evt) => {
                    this.search(Number(this.state.page) + 1);
                  }}>Next</PaginationLink></PaginationItem>
                )}
              </Pagination>
            </Fragment>
          ) : (
            <div>No results try your request again with different parameters</div>
          ) : (
            <div>Enter your search criteria above to search for user</div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary"
                  onClick={() => this.props.onClose()}>Close</Button>
        </ModalFooter>
      </Modal>
    );
  }

  generatePageLinks() {
    const pages = [];
    let maxPages = this.maxPages();
    if (maxPages > 15) {
      maxPages = 16
    }
    for (let pageNum = 0; pageNum < maxPages; pageNum++) {
      pages.push({
        num: pageNum + 1,
        active: pageNum + 1 === Number(this.state.page)
      });
    }
    return pages;
  }
}



// WEBPACK FOOTER //
// ./src/components/LMSUserPicker/LMSUserPicker.js